import React from 'react';

import { Stack, Typography } from '@mui/material';

import styles from './MetricRow.module.css';

interface MetricRowProps {
  label: string;
  children: React.ReactNode;
}

export function MetricRow({ label, children }: MetricRowProps) {
  return (
    <Stack direction="row" spacing={2} className={styles.metricRow}>
      <Typography variant="body2" className={styles.metricLabel}>
        {label}
      </Typography>
      {children}
    </Stack>
  );
}
